import { render, staticRenderFns } from "./EvaluatorTestView.vue?vue&type=template&id=2b6dd105&"
import script from "./EvaluatorTestView.vue?vue&type=script&lang=js&"
export * from "./EvaluatorTestView.vue?vue&type=script&lang=js&"
import style0 from "./EvaluatorTestView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VDivider,VList,VListItem,VListItemGroup,VRadio,VRadioGroup})
